var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.196 21.814L8.409 16.6l3.772 3.771 6.095-6.093 2.39 2.389V10H14l2.39 2.391-4.209 4.21-3.77-3.773-6.595 6.595A13.287 13.287 0 01.666 14C.667 6.636 6.637.667 14 .667S27.333 6.637 27.333 14c0 7.364-5.969 13.334-13.333 13.334a13.317 13.317 0 01-10.804-5.52z",
    fill: "#529ED0"
  })));
}
export default SvgGrowthLogo;